import { render, staticRenderFns } from "./RecordsPage.vue?vue&type=template&id=707291f0&scoped=true&"
import script from "./RecordsPage.vue?vue&type=script&lang=js&"
export * from "./RecordsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707291f0",
  null
  
)

export default component.exports